import config from "../../app.json";
import axios from "axios";

import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import AlertComponent from "../../Components/AlertComponent";
import FieldText from "../../Components/Fields/FieldText";
import FieldUploadMultipart from "../../Components/Fields/FieldUploadMultipart";

function SeriesDetail({ general = false }) {
  let navigate = useNavigate();
  const { id } = useParams();

  const [data, setData] = useState(null);
  const [name, setName] = useState(general ? "General" : "");
  const [cover, setCover] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (general)
      fetchGeneralSeries();
    else if (id)
      fetchSeries();
  }, [id, general]);

  const fetchSeries = () => {
    axios.post(config.API + "/api/series/getSeries", {
      id
    }).then((res) => {
      setData(res.data);
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.response?.data?.message || error?.message, { icon: `error` });
    });
  };

  const fetchGeneralSeries = () => {
    axios.post(config.API + "/api/series/getGeneralSeries").then((res) => {
      setData(res.data);
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.response?.data?.message || error?.message, { icon: `error` });
    });
  };

  useEffect(() => {
    setName(general ? "General" : (data?.name ?? ""));
    setCover(data?.cover);
  }, [data]);

  const handleCoverUpload = (u) => {
    setCover(u);

    // Any size is accepted — just warn the user when the image is not 16:9
    const img = new Image();
    img.onload = () => {
      if (Math.abs(img.height - (img.width * 9) / 16) > 1)
        AlertComponent("Warning", "The uploaded image is " + img.width + "x" + img.height + ". For best results, use a 16:9 image (1920x1080 recommended).", { icon: `warning` });
    };
    img.src = config.API + "/api/file/download/?guid=" + u.guidFile + "&temp=true";
  };

  const handleSave = (e) => {
    e.preventDefault();

    if (uploading)
      return AlertComponent("Error", "You must wait the upload finish to continue.", { icon: `error` });

    if (!general && !name?.trim())
      return AlertComponent("Error", "You must enter a series name.", { icon: `error` });

    if (!cover)
      return AlertComponent("Error", "You must upload a series cover image.", { icon: `error` });

    if (general) {
      axios.post(config.API + "/api/series/saveGeneralSeries", {
        cover
      }).then((res) => {
        AlertComponent("Success", "General series cover was updated successfully!");
        return navigate("/videoArchive/series", { replace: false });
      }).catch(function (error) {
        return AlertComponent("Error", error?.response?.data?.error || error?.response?.data?.message || error?.message, { icon: `error` });
      });
      return;
    }

    axios.post(config.API + "/api/series/saveSeries", {
      id,
      name,
      cover
    }).then((res) => {
      AlertComponent("Success", id ? "Series was updated successfully!" : "Series was created successfully!");
      return navigate("/videoArchive/series", { replace: false });
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.response?.data?.message || error?.message, { icon: `error` });
    });
  };

  return (
    <form onSubmit={handleSave}>
      <Row className="edit-video-archive" style={{ marginTop: 40, display: 'flex', flexDirection: 'row', marginBottom: 40 }}>
        <Col md="10" className="cc-card">
          <h5>{general ? "Editing General Series" : (id ? "Editing Series" : "New Series")}</h5>
          <Row>
            <Col md="6">
              <FieldText
                label="Name"
                type="text"
                onChange={(x) => setName(x.target.value)}
                placeholder="Series Name"
                value={name}
                readonly={general}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FieldUploadMultipart
                onUploadComplete={handleCoverUpload}
                accept={["image/png", "image/jpg", "image/jpeg"]}
                label={"Series Cover (16:9, 1920x1080 recommended)"}
                maxSize={100 * 1024 * 1024} // 100 MB
                required={false}
                onStateChanged={setUploading}
                data={cover}
                customPreview={(file) => {
                  return (<div className="series-cover" style={{ backgroundImage: 'url(' + config.API + '/api/file/download/?guid=' + file.guidFile + '&temp=' + (file.id == null) + ')' }}></div>)
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col style={{ marginTop: 40, display: 'flex', justifyContent: 'flex-end' }}>
              <Button className="dark-btn" type="submit">
                Save
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </form>
  );
}

export default SeriesDetail;
